import axiosInstance from 'common/js/axios-service'

export const receiveAutoCharCodeTrialCount = params => {
  return axiosInstance.request({
    url: 'activity/receive_auto_char_code_trial_count.json',
    params
  })
}
